<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M10 .833c5.063 0 9.167 4.104 9.167 9.167S15.063 19.167 10 19.167.833 15.063.833 10 4.937.833 10 .833zM10 2.5c-4.142 0-7.5 3.358-7.5 7.5 0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5 0-4.142-3.358-7.5-7.5-7.5zm-.59 9.41c.326-.325.854-.325 1.18 0 .325.326.325.854 0 1.18-.326.325-.854.325-1.18 0-.325-.326-.325-.854 0-1.18zM10 5.834c.425 0 .775.318.827.73l.006.104V10c0 .46-.373.833-.833.833-.425 0-.775-.318-.827-.728L9.167 10V6.667c0-.46.373-.834.833-.834z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-warning",
  components: {},
})
export class IconWarning extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconWarning;
</script>
